<div class="flex min-w-0 w-full flex-col gap-5">
  @if (isMobile()) {
    <proffeo-ui-select
      [(value)]="mobileGrouping"
      [multiple]="false"
      [options]="mobileGroupingOptions"
      [translateLabels]="true"
      label="proffeo-ui-table.group-by"
      class="min-w-0 w-full"
    />

    <!-- PROPOZYCJA — DO WERYFIKACJI: move My Tasks into the existing mobile filters dialog. -->
    <proffeo-ui-select
      [(value)]="myRolesSelection"
      [multiple]="true"
      [options]="myRolesOptions"
      [proffeoFilterCountBadge]="myRolesBadgeCount()"
      [selectAllLabel]="'task-filters.selectAll'"
      [triggerDisplay]="'full'"
      [translateLabels]="true"
      label="task-filters.myTasks"
      class="min-w-0 w-full"
    />
  }
  <section class="flex min-w-0 w-full flex-col gap-3">
    <h3 class="proffeo-ui-text-muted">{{ 'task-filters.sections.dates' | translate }}</h3>

    <div class="grid min-w-0 w-full grid-cols-1 gap-3">
      <proffeo-ui-date-range-picker
        [(value)]="startDateRange"
        [proffeoFilterCountBadge]="isProffeoUiDateRangeActive(startDateRange()) ? 1 : 0"
        appearance="field"
        endPlaceholder="task-filters.dateTo"
        label="task-filters.startDate"
        startPlaceholder="task-filters.dateFrom"
        class="min-w-0"
      />

      <proffeo-ui-date-range-picker
        [(value)]="endDateRange"
        [proffeoFilterCountBadge]="isProffeoUiDateRangeActive(endDateRange()) ? 1 : 0"
        appearance="field"
        endPlaceholder="task-filters.dateTo"
        label="task-filters.endDate"
        startPlaceholder="task-filters.dateFrom"
        class="min-w-0"
      />

      <proffeo-ui-date-range-picker
        [(value)]="createdDateRange"
        [maxDate]="today()"
        [proffeoFilterCountBadge]="isProffeoUiDateRangeActive(createdDateRange()) ? 1 : 0"
        appearance="field"
        endPlaceholder="task-filters.dateTo"
        label="task-filters.createDate"
        startPlaceholder="task-filters.dateFrom"
        class="min-w-0"
      />

      <proffeo-ui-date-range-picker
        [(value)]="editDateRange"
        [maxDate]="today()"
        [proffeoFilterCountBadge]="isProffeoUiDateRangeActive(editDateRange()) ? 1 : 0"
        appearance="field"
        endPlaceholder="task-filters.dateTo"
        label="task-filters.editDate"
        startPlaceholder="task-filters.dateFrom"
        class="min-w-0"
      />
    </div>
  </section>

  <section class="flex min-w-0 w-full flex-col gap-3">
    <h3 class="proffeo-ui-text-muted">{{ 'task-filters.sections.taskData' | translate }}</h3>

    <ng-template
      #tagOptionTemplate
      let-option
    >
      <proffeo-tag [tag]="option.context" />
    </ng-template>

    <div
      [class.grid-cols-1]="isMobile()"
      [class.grid-cols-2]="!isMobile()"
      class="grid min-w-0 w-full gap-3"
    >
      <proffeo-ui-select
        [(value)]="taskStatusSelection"
        [multiple]="true"
        [options]="statusOptions()"
        [proffeoFilterCountBadge]="taskStatusBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.status"
        class="min-w-0"
      />

      <proffeo-ui-select
        [(value)]="taskPrioritySelection"
        [multiple]="true"
        [options]="priorityOptions()"
        [proffeoFilterCountBadge]="taskPriorityBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.priority"
        class="min-w-0"
      />

      <proffeo-ui-select
        [(value)]="taskTypeIdsSelection"
        [multiple]="true"
        [options]="taskTypesOptions()"
        [proffeoFilterCountBadge]="taskTypeBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.taskType"
        class="min-w-0"
      />

      <proffeo-ui-select
        [(value)]="projectTagIdsSelection"
        [multiple]="true"
        [optionTemplate]="tagOptionTemplate"
        [options]="tagsOptions()"
        [proffeoFilterCountBadge]="projectTagIdsBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.tags"
        class="min-w-0"
      />

      <proffeo-ui-select
        [(value)]="industrySelection"
        [enableEmptyValue]="true"
        [multiple]="true"
        [options]="industriesOptions()"
        [proffeoFilterCountBadge]="industryBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.industry"
        class="min-w-0"
      />

      <proffeo-ui-tree-select
        [(value)]="locationSelection"
        [enableEmptyValue]="true"
        [multiple]="true"
        [nodes]="taskFiltersService.locationTreeNodes()"
        [proffeoFilterCountBadge]="locationBadgeCount()"
        [searchable]="true"
        [translateLabels]="false"
        emptyValueLabel="task-filters.emptyValue"
        label="task-filters.locations"
        triggerDisplay="full"
        class="min-w-0"
      />
    </div>
  </section>

  <section class="flex min-w-0 w-full flex-col gap-3">
    <h3 class="proffeo-ui-text-muted">{{ 'task-filters.sections.users' | translate }}</h3>

    <div
      [class.grid-cols-1]="isMobile()"
      [class.grid-cols-2]="!isMobile()"
      class="grid min-w-0 w-full gap-3"
    >
      <proffeo-ui-select
        [(value)]="userSelection"
        [enableEmptyValue]="true"
        [multiple]="true"
        [options]="usersOptions()"
        [proffeoFilterCountBadge]="userBadgeCount()"
        [searchable]="true"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        emptyValueLabel="task-filters.emptyValue"
        label="task-filters.users"
        class="min-w-0"
      />

      <proffeo-ui-tree-select
        [(value)]="groupSelection"
        [multiple]="true"
        [nodes]="taskFiltersService.groupTreeNodes()"
        [proffeoFilterCountBadge]="groupBadgeCount()"
        [searchable]="true"
        [translateLabels]="false"
        label="task-filters.groups"
        triggerDisplay="full"
        class="min-w-0"
      />

      <mat-form-field
        (click)="onSelectUserRoleClick($event)"
        [proffeoFilterCountBadge]="userRoleBadgeCount()"
        [matTooltip]="userRoleDisplayValue()"
        [matTooltipDisabled]="!userRoleDisplayValue()"
        class="min-w-0 cursor-pointer"
      >
        <mat-label>{{ 'task-filters.user-role' | translate }}</mat-label>
        <input
          [value]="userRoleDisplayValue()"
          matInput
          readonly
          class="truncate cursor-pointer"
        />
      </mat-form-field>

      <proffeo-ui-select
        [(value)]="createdBySelection"
        [multiple]="true"
        [options]="usersOptions()"
        [proffeoFilterCountBadge]="createdByBadgeCount()"
        [selectAllLabel]="'task-filters.selectAll'"
        [triggerDisplay]="'full'"
        label="task-filters.createdBy"
        class="min-w-0"
      />
    </div>
  </section>
</div>
